import { render, staticRenderFns } from "./OnboardingIndex.vue?vue&type=template&id=a0639f68&scoped=true&"
import script from "./OnboardingIndex.vue?vue&type=script&lang=js&"
export * from "./OnboardingIndex.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIndex.vue?vue&type=style&index=0&id=a0639f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0639f68",
  null
  
)

export default component.exports